import React, { Fragment, useContext, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { fetchRegistrationCode, login } from "../../actions/security";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import { Button, TextField, IconButton, InputAdornment } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import VerificationCodeInput from "../../components/Reusable/VerificationCodeInput";

const RegistrationCode = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { t } = useTranslation(); // Koristi useTranslation za prevođenje

  const [state, setState] = useState({
    code: "",
  });

  const onSubmitHandler = (event) => {
    event.preventDefault();
    // alert(state.code);
    dispatch(fetchRegistrationCode(state, navigate));
  };

  const onChangeHandlerOtp = (value) => {
    // Ažuriramo stanje u roditeljskoj komponenti
    setState((prevState) => ({ ...prevState, code: value }));
  };

  return (
    <Fragment>
      <Header nameClass={"backgorund-color-header"} />
      <div className="login-page-holder">
        <div className="login-page-image">
          <div className="login-page-image-title">
            <h1>{t("registrationCode.label")}</h1>
          </div>
        </div>
        <div className="login-content-form" style={{ padding: "0px 25px" }}>
          <h2>{t("registrationCode.title")}</h2>
          <form onSubmit={onSubmitHandler}>
            <Row>
              <Col lg={12} className="mb-3">
                <VerificationCodeInput onChange={onChangeHandlerOtp} />
              </Col>
              <Col className="login-button-item">
                <Button type="submit">{t("registrationCode.button")}</Button>
              </Col>
            </Row>
          </form>
          <div className="registration-section-login-page d-flex justify-content-between align-items-center">
            <div className="registration-return-button-login">
              <Link to="/login"> {t("login.prijava")}</Link>
            </div>
            <div className="registration-button">
              <Link to="/registration">{t("login.registruj_se")}</Link>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default RegistrationCode;
